import React from 'react';
import moment from 'moment';
import IconList from '../../../UI/Icons/IconList';

const NotificationItem = ({
  title,
  replace,
  date,
  isUnread,
  onClick,
}) => {
  const getTitle = (titleText, replaceProperties) => {
    let result = titleText;
    // eslint-disable-next-line
    for (const i in replaceProperties) {
      // eslint-disable-next-line
      const reg = new RegExp(':' + i, 'g');
      result = result.replace(reg, `<b>${replaceProperties[i]}</b>`);
    }

    return result;
  };

  return (
    <div
      className={`notifications__item ${isUnread ? 'is-unread' : ''}`}
      onClick={onClick}
    >
      <div
        className="notifications__item__image"
        style={{ backgroundColor: '#f3f8f6' }}
      >
        <IconList color="#12b862" />
      </div>
      <div className="notifications__item__body">
        <div className="notifications__item__title" dangerouslySetInnerHTML={{ __html: getTitle(title, replace) }} />
        <div className="notifications__item__subtitle">{moment(date).utc().format('DD MMM YYYY h:mm a')}</div>
      </div>
    </div>
  );
};

export default NotificationItem;
